import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Hooks
import { useUniqueId } from 'src/hooks'

// Components
import { Text } from 'src/Components'

// Styles
import styles from './DropdownItem.module.scss'

const propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  selectedOption: PropTypes.string,
  setSelectedOption: PropTypes.func,
  setOpen: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

const DropdownItem = ({
  className,
  id,
  label,
  onClick,
  selectedOption,
  setSelectedOption,
  value,
  setOpen
}) => {
  const activePage = selectedOption === id

  const handleOnClick = useCallback(
    e => {
      const id = e.target.id
      onClick && onClick(e)
      setSelectedOption && setSelectedOption(id)
      setOpen(false)
    },
    [setSelectedOption, onClick, setOpen]
  )

  return (
    <li className={styles.listItem}>
      <Text
        className={classnames(
          className,
          styles.buttonText,
          activePage && styles.activeItem
        )}
        disabled={activePage}
        element='button'
        id={id}
        key={id}
        onClick={handleOnClick}
        tabIndex={0}
        value={value}
      >
        {label}
      </Text>
    </li>
  )
}

const DropdownItemDivider = () => {
  const dividerId = useUniqueId('dropdownItem_diver_')

  return (
    <li key={dividerId} className={styles.dividerContainer}>
      <hr className={styles.divider} />
    </li>
  )
}

DropdownItem.propTypes = propTypes
DropdownItem.displayName = 'DropdownItem' // for error handling
DropdownItemDivider.displayName = 'DropdownItem' // for error handling

export { DropdownItem, DropdownItemDivider }
